<!--<data-table #packageListTable [bigTable]="true" [columns]="columns" [csvExport]="true" [dataProviderParams]="params"
                [dataProvider]="packageService" [perPage]="true" [title]="'Customers List'">
</data-table>-->

<data-table #packageListTable [bigTable]="true" [columns]="columns" [dataProviderParams]="params" [dataProvider]="packageService"
                [perPage]="true" [title]="'Customers List'">
</data-table>
